import { useEffect, useState } from "react"

export function useSelectable({ primaryKey, selectedFieldName = '_selected' }) {

    const [selectableData, setSelectableData] = useState()
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [totalRowSelected, setTotalRowSelected] = useState(0)
    const [selectedKeys, setSelectedKeys] = useState([])

    useEffect(() => {

        updateTotalRowSelected()

        // }, [selectableData])
    }, [])

    const handleSelectAll = () => {

        let selectAll = !isSelectAll

        setIsSelectAll(selectAll)

        let newData = selectableData.map(item => {
            item[selectedFieldName] = selectAll
            return item
        })

        setSelectableData(newData)

        let _selectedKeys = []

        if (selectAll === true) {
            _selectedKeys = selectableData.map(i => i[primaryKey])
        }

        setSelectedKeys(_selectedKeys)

    }

    const handleSelectRow = ({ row }) => {

        let newData = []
        let _selectedKeys = []

        selectableData.forEach(i => {

            let item = i

            if (row[primaryKey] === i[primaryKey]) {
                item[selectedFieldName] = !row[selectedFieldName]
            }

            if (item[selectedFieldName] === true) {
                _selectedKeys.push(i[primaryKey])
            }

            newData.push(item)
        })

        // check if all rows is selected
        const countSelected = newData.filter(i => i[selectedFieldName] === true)
        const countUnSelected = newData.filter(i => i[selectedFieldName] === false)

        console.log('countSelected', countSelected, countUnSelected, newData.length)

        if (countSelected.length === newData.length) { // all selected
            setIsSelectAll(true)
        }

        if (countUnSelected.length === newData.length) { // all unselected
            setIsSelectAll(false)
        }

        setSelectableData(newData)
        setSelectedKeys(_selectedKeys)

    }

    const getRowSelectStatus = ({ row }) => {
        const check = selectableData.filter(item => {

            if (item[primaryKey] === row[primaryKey]) {
                return true;
            }

            return false;

        })

        if (check.length) {
            return check[0][selectedFieldName]
        }

        return false;
    }

    const updateTotalRowSelected = () => {

        if (!selectableData) return false;

        const check = selectableData.filter(item => item.selected === true)
        setTotalRowSelected(check.length)

        let values = [];
        check.forEach(item => values.push(item[primaryKey]))

        // check is all selected
        setIsSelectAll(check.length === selectableData.length)
        setSelectedKeys(values)

        return true;
    }

    return {
        selectableData,
        setSelectableData,
        isSelectAll,
        handleSelectAll,
        handleSelectRow,
        getRowSelectStatus,
        totalRowSelected,
        selectedKeys
    }
}